import { noShortcutTheme } from "../../../interactive-tutorial/lib/Theme";

export default noShortcutTheme;
